var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
var RadomPaymentMethodIcon = function (_a) {
    var mainIcon = _a.mainIcon, networkIcon = _a.networkIcon;
    return (_jsxs(Box, __assign({ position: "relative", width: 32, height: 32, display: "inline-block" }, { children: [_jsx(Box, { component: "img", src: mainIcon, alt: "Main Token", width: 32, height: 32, sx: { borderRadius: "50%" } }), _jsx(Box, { component: "img", src: networkIcon, alt: "Network", width: 15, height: 15, sx: {
                    position: "absolute",
                    bottom: -2,
                    right: -2,
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    border: "1px solid #e0e0e0",
                    boxShadow: "0 0 2px rgba(0,0,0,0.15)",
                } })] })));
};
export default RadomPaymentMethodIcon;
